import * as React from 'react';
export const paystackSvg = React.forwardRef(function paystackSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#011B33',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.588 16.57H7.974a.968.968 0 0 0-.974.962v1.722c0 .531.436.962.974.962h15.614c.538 0 .974-.43.974-.962v-1.722a.968.968 0 0 0-.974-.962Zm.976-4.785H7.974a.968.968 0 0 0-.974.962v1.722c0 .531.436.962.974.962h16.59c.538 0 .974-.43.974-.962v-1.722a.968.968 0 0 0-.974-.962ZM23.588 7H7.974A.968.968 0 0 0 7 7.962v1.722c0 .531.436.962.974.962h15.614c.538 0 .974-.43.974-.962V7.962A.968.968 0 0 0 23.588 7Zm-6.814 14.355h-8.8a.968.968 0 0 0-.974.962v1.721c0 .532.436.962.974.962h8.8c.538 0 .975-.43.975-.962v-1.721a.968.968 0 0 0-.975-.962Z',
      fill: '#00C3F7',
    }),
  );
});
paystackSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var paystack = {
  category: 'brand',
  colorable: false,
  name: 'paystack',
  svg: paystackSvg,
};
